<template>
  <div>
    <div class="container">
      <div class="columns is-desktop">
        <div class="column is-three-fifths"> 
          <!-- <div class="card">11/6に予測モデルの更新を行いました。
            <router-link to="/info">info</router-link>
          </div> -->
          <forecast-map/>
        </div>
        <div class="column is-two-fifths"> 
          <!--<div class="column is-two-fifths" :key="selected"> ならafter-leaveがいらないけどkeyが要るのとleaveが見えない -->
          <transition appear name="fade1" v-on:after-leave="show=true">
            <forecast-panel v-if="show" ref="today" day="today" class="mb-20"></forecast-panel>
          </transition>
          <transition appear name="fade2" >
            <forecast-panel v-if="show" ref="tommorow" day="tomorrow" ></forecast-panel>
          </transition>
        </div>
      </div>
      <background />
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import ForecastPanel from '@/components/ForecastPanel'
import ForecastMap from '@/components/ForecastMap'
import Background from '@/components/Background'

export default {
  name: 'ForecastMain',
  components: {
    Navbar, ForecastPanel,ForecastMap, Background
  },
  data () {
    return {
      show: true
    }
  },
  watch: {
    '$route' (to, from) {
      // ルートの変更の検知...
      this.show = false
      this.$refs.today.findPanelForecast()
      this.$refs.tommorow.findPanelForecast()

    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.fade1-enter-active{
  transition: all .7s .1s;
}
.fade2-leave-active {
  transition: all .3s .0s;
}
.fade2-enter, .fade2-leave-to, .fade1-enter, .fade1-leave-to{
  transform: translateY(20px);
  opacity: 0;
}
.fade2-enter-active {
  transition: all .7s .4s;
}
.fade1-leave-active {
  transition: all .3s .2s;
}

</style>



// WEBPACK FOOTER //
// src/components/ForecastMain.vue